import React, { useEffect, useState } from 'react'
import useFetch from 'use-http'

import { Box, Button, Card, Heading, Inline, Modal, SelectField, Stack, TextField } from '@myxplor/stardust'

interface Props {
  featureSets: Papi.FeatureSet[]
  isOpen: boolean
  service: Papi.Service
  onCancel(): void
  onSave(plan: Papi.ServicePlan): void
}

const PlanChangeModal = ({ featureSets, isOpen, service, onCancel, onSave }: Props) => {
  const [planModel, setPlanModel] = useState<Nullable<Record<string, any>>>(null)

  const planRequest = useFetch(`/api/v1/services/${service.id}/plans`)

  const onChange = (field: string, value: number | string) => {
    setPlanModel((model: any) => ({ ...model, [field]: value }))
  }

  const handleSave = async () => {
    if (planModel) {
      const response = await planRequest.post(planModel)

      onSave(response.data)
    }
  }

  useEffect(() => setPlanModel({}), [isOpen])

  if (!planModel) {
    return null
  }

  const featureSetOptions = featureSets.reduce((acc, featureSet) => {
    return { ...acc, [featureSet.id]: featureSet.name }
  }, {})

  const isValid = !!planModel.feature_set_id

  return (
    <Modal backdrop isOpen={isOpen} onBlur={onCancel}>
      <Card>
        <Box minWidth={600} padding="small">
          <Stack space="small">
            <Heading level={5}>Change Plan</Heading>
            <SelectField
              items={featureSetOptions}
              label="Plan"
              required
              onSelect={(value: string) => onChange('feature_set_id', value)}
            />
            <TextField
              label="Start date from (optional, default to now)"
              type="date"
              onChange={(value) => onChange('start_date', value)}
            />
            <TextField
              label="Finish date (optional, defaults to never ending)"
              type="date"
              onChange={(value) => onChange('end_date', value)}
            />
            <Inline align="right" space="small">
              <Button variant="outline" onClick={onCancel}>
                Cancel
              </Button>
              <Button disabled={!isValid} onClick={handleSave}>
                Save
              </Button>
            </Inline>
          </Stack>
        </Box>
      </Card>
    </Modal>
  )
}

export default React.memo(PlanChangeModal)
